export default __webpack_public_path__ + "static/media/not-found.f2f77010.jpg";